export const eyeIconSrc = "https://civcdn.dodmets.com/css/bootstrap-icons/1.8.3/icons/eye.svg";
export const eyeSlashIconSrc = "https://civcdn.dodmets.com/css/bootstrap-icons/1.8.3/icons/eye-slash.svg";
export const checkLgIconSrc = "https://civcdn.dodmets.com/css/bootstrap-icons/1.8.3/icons/check-lg.svg";